require('@fancyapps/fancybox/dist/jquery.fancybox');

import {AppDetail} from './modules/catalog/detail';


$(document).on('click', '#pageShareLink', function(e){
    e.preventDefault();
    var url = $(this).data('link');
    var title = $(this).data('name');
    var text = $(this).data('text');

    navigator.share({url: url, title: title, text: text})
    .catch((error) => console.log('Ошибка при попытке поделиться:', error));
});

function productSliderInit(slider, navSlider){
    $(slider).slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        arrows: false,
        fade: true,
        dots: true,
        asNavFor: navSlider
    })

    $(navSlider).slick({
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 1,        
        asNavFor: slider,
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        draggable: false,
        centerPadding: '0px',
        appendArrows: $( " .slider-arrowsBlock"),
        prevArrow: "<span class='prevArr'><svg width='24' height='24'><use xlink:href='/img/svg/common.svg#svg_arrow_slick_prev'></use></svg></span>",
        nextArrow: "<span class='nextArr'><svg width='24' height='24'><use xlink:href='/img/svg/common.svg#svg_arrow_slick_next'></use></svg></span>",
    })

    let slidersAmount = $(slider + " .slick-dots li").length;
    $(".slider-arrowsBlock .total").text(slidersAmount);

    $(".nav-slider").on("afterChange", function () {
        let slideNum = $(slider + " .slick-dots .slick-active").find("button").text();
        $(".slider-arrowsBlock .num").text(slideNum);
    })

    $(navSlider).find('.slick-slide').on('click', function(e){
        $(navSlider).slick('slickGoTo', $(e.currentTarget).data('slick-index'));
    })
}

function changeQuantity(inputBlock){
    let input = $(inputBlock).find('.price-input'),
        minus = $(inputBlock).find('.minus'),
        plus = $(inputBlock).find('.plus'),
        inputValue;
    
        
    minus.on('click', () => input.val() > 1 ? input.val(+input.val()-1) : input.val(1));
    plus.on('click', () => input.val(+input.val()+1));

    input.on('focus', ()=>{
        inputValue = input.val();
        input.val(null)
    })
    input.on('blur', ()=>{
        if(inputValue &&  input.val() == ''){
            input.val(inputValue)
        }

        if(input.val() < 1){
            input.val(1)
        }
    })
}

function recomendedSliderInit(slider){
    $(slider).slick({
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        focusOnSelect: true,
        centerMode: false,
        swipeToSlide: true,
        draggable: false,
        prevArrow: "<span class='prevArr'><svg width='24' height='24'><use xlink:href='/img/svg/common.svg#svg_arrow_slick_prev'></use></svg></span>",
        nextArrow: "<span class='nextArr'><svg width='24' height='24'><use xlink:href='/img/svg/common.svg#svg_arrow_slick_next'></use></svg></span>",
        responsive:[
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 4,
                    arrows: true
                }
            },
            {
                breakpoint: 1240,
                settings: {
                    slidesToShow: 4,
                    arrows: true
                }
            },
            {
                breakpoint: 890,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 606,
                settings: {
                    arrows: true,
                    centerPadding: '30px',
                    slidesToShow: 1,
                }
            },
        ]
    })
}

$(function(){

    productSliderInit('.product-slider', '.nav-slider');
    changeQuantity('.price-block .quantity');

    // инициализация работы с характеристиками в карточке товара
    new AppDetail('catalog-item-detail', window.app_product_detail);

    
    recomendedSliderInit('.slider_set');
    
});